import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-aoi-tool',
  templateUrl: './aoi-tool.component.html',
  styleUrls: ['./aoi-tool.component.css']
})
export class AoiToolComponent implements AfterViewInit {
  @ViewChild('stateTab', { static: false }) private readonly stateTab: ElementRef<any>;
  @ViewChild('regionTab', { static: false }) private readonly regionTab: ElementRef<any>;
  @ViewChild('routeTab', { static: false }) private readonly routeTab: ElementRef<any>;
  @ViewChild('assetIdTab', { static: false }) private readonly assetIdTab: ElementRef<any>;
  @ViewChild('addressTab', { static: false }) private readonly addressTab: ElementRef<any>;
  @ViewChild('latLongTab', { static: false }) private readonly latLongTab: ElementRef<any>;
  @ViewChild('intersectionTab', { static: false }) private readonly intersectionTab: ElementRef<any>;

  @Output('done') done: EventEmitter<boolean> = new EventEmitter();

  @Output('newAoi') newAoi: EventEmitter<any> = new EventEmitter();

  isLoading: boolean;

  aoiTabs = [
    { name: "State" },
    { name: "Region", active: true },
    { name: "Route" },
    { name: "Asset Id" },
    { name: "Address" },
    { name: "Lat/Long"},
    { name: "Intersection" }
  ];

  activeTab: any;
  aoiService: any;
  layerService: any;
  mapService: any;

  assetIdConfig = [
    {
      columnName: 'HPMS_SAMP_SECT_NO',
      displayName: 'HPMS Sample IDs',
      idType: '$stringIds',
      propName: 'samples',
      fieldName: 'sampleId',
      layerId: 2000
    },
    {
      columnName: 'BRKEY',
      displayName: 'Bridge Keys',
      idType: '$stringIds',
      propName: 'bridges',
      fieldName: 'brKey',
      layerId: 1592
    },
    {
      columnName: 'PERMIT_NUM',
      displayName: 'Permit Numbers',
      idType: '$stringIds',
      propName: 'permitNums',
      fieldName: 'permitNum',
      layerId: 9144
    },
    {
      columnName: 'APPLICATION_ID',
      displayName: 'Permit Applications',
      idType: '$stringIds',
      propName: 'permitApps',
      fieldName: 'permitApp',
      layerId: 9144
    },
    {
      columnName: 'PROJECT_ID',
      displayName: 'MPMS Projects',
      idType: '$stringIds',
      propName: 'mpmsprojects',
      fieldName: 'id',
      layerId: 2751
    },
    {
      columnName: 'TMS_SITE_NO',
      displayName: 'TMS Site Numbers',
      idType: '$stringIds',
      propName: 'tmsSite',
      fieldName: 'tmsSiteNo',
      layerId: 2611
    },
    {
      columnName: 'SIGN_APPL_ID',
      displayName: 'Billboard IDs',
      idType: "$stringIds",
      propName: 'billboards',
      fieldName: 'bilboardId',
      layerId: 6763
    }
  ];

  assetIdProperties = 'samples,bridges,permitNums,permitApps,mpmsprojects,tmsSite,billboards'
  constructor() { }
  ngAfterViewInit() {
    this.aoiService = this.stateTab.nativeElement.AoiService;
    this.activeTab = this.regionTab;
    this.assetIdTab.nativeElement.config = this.assetIdConfig;
    this.assetIdTab.nativeElement.properties = this.assetIdProperties;
  }

  activateTab() {
    this.activeTab.nativeElement.activate();
  }

  onTabChange(event) {
    switch (event.detail.name) {
      case 'State':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.stateTab;
        this.activateTab();
        break;

      case 'Region':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.regionTab;
        this.activateTab();
        break;

      case 'Route':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.routeTab;
        this.activateTab();
        break;

      case 'Asset Id':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.assetIdTab;
        this.activateTab();
        break;

      case 'Address':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.addressTab;
        this.activateTab();
        break;

      case 'Lat/Long':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.latLongTab;
        this.activateTab();
        this.latLongTab.nativeElement.activate(); //loads latLong map
        break;

      case 'Intersection':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.intersectionTab;
        this.activateTab();
        break;

      default:
        break;
    }
  }

  public async go() {
    try {
      this.isLoading = true;
      this.activeTab.nativeElement.addResultToMap();
      await this.aoiService.showBySearchCriterias();
      this.newAoi.emit();

    } catch (error) {
      console.error(error);
      this.log('Error moving to Area of Interest.', 5, false);
    } finally {
      this.isLoading = false;
      this.closeAoiTool();
      this.log('Showing Area of Interest.', 3, false);
    }
  }

  closeAoiTool() {
    this.done.emit(true);
  }


  log(message: string, level: number, isPrivate: boolean) {
    if (level > 6) {
      let applicationMessage = new CustomEvent('applicationMessage', { detail: { message: 'Something very bad happened, please refresh!', level: level, isPrivate: isPrivate ? isPrivate : false }, composed: true });
      window.dispatchEvent(applicationMessage);
    } else {
      let applicationMessage = new CustomEvent('applicationMessage', { detail: { message: message, level: level, isPrivate: isPrivate ? isPrivate : false }, composed: true });
      window.dispatchEvent(applicationMessage);
    }
  };
}

